<template>
    <v-combobox
        v-model="model"
        :items="items"
        chips
        :label="label"
        multiple
        outlined
        @change="changeValue"
    >
        <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
                v-bind="attrs"
                :input-value="selected"
                @click="select"
            >
                <strong>{{ item.text }}</strong>&nbsp;
            </v-chip>
        </template>
    </v-combobox>
</template>
<script>
export default {

    data(){
        return{
            chips: []
        }
    },

    props: ["label", "items", "model"],
    
    methods:{
        changeValue(items){
            this.$emit('valueChanged', items);
        }
    }
}
</script>